import React from 'react';
import { Col, Card, Row, Button } from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const styles = {
  card: {
    backgroundColor: "#17296B",
    height: '100%',
  },
  container: {
    margin: '1rem',
  },
  rowHeader: {
    borderBottom: '1px solid #fff',
  },
  title: {
    fontSize: "2.5vmin",
    color: '#fff',
  },
  buttonLink: {
    color: '#fff',
    textDecoration: 'none',
    fontSize: '2vmin',
  },
  monthNavigation: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#fff',
  },
  calendarWrapper: {
    backgroundColor: '#0E46A3', 
    padding: '2px',
    borderRadius: '10px',
  },
  calendarGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: '2px',
    color: '#fff',
    textAlign: 'center',
  },
  calendarCell: {
    padding: '2px',
    borderRadius: '5px',
  },
  highlight: {
    backgroundColor: '#17296B',
    color: '#fff',
  },
};

const Calendarb2b = () => (
  <Col className='col-6'>
    <Card className='rounded-4 shadow' style={styles.card}>
      <div style={styles.container}>
        <Row style={styles.rowHeader}>
          <Col>
            <b style={styles.title}>Calendário</b>
          </Col>
          <Col className='text-end'>
            <Button variant="link" style={styles.buttonLink}>Ver detalhes</Button>
          </Col>
        </Row>
        <div>
          <div style={styles.monthNavigation}>
            <Button variant="link" style={styles.buttonLink}>
              <FaChevronLeft /> {/* Ícone para mês anterior */}
            </Button>
            <span>Quinta-feira, 3 de Janeiro de 2025</span>
            <Button variant="link" style={styles.buttonLink}>
              <FaChevronRight /> {/* Ícone para próximo mês */}
            </Button>
          </div>
          <div style={styles.calendarWrapper}>
            <div style={styles.calendarGrid}>
              {/* Cabeçalhos dos dias da semana */}
              {['Seg.', 'Ter.', 'Qua.', 'Qui.', 'Sex.', 'Sáb.', 'Dom.'].map((day, index) => (
                <div key={index} style={{ fontWeight: 'bold' }}>{day}</div>
              ))}
              {/* Dias do mês */}
              {[...Array(31)].map((_, index) => (
                <div
                  key={index}
                  style={{
                    ...styles.calendarCell,
                    ...(index === 2 ? styles.highlight : {}), // Destaque no dia 3
                  }}
                >
                  {index + 1}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Card>
  </Col>
);

export default Calendarb2b;
